// extracted by mini-css-extract-plugin
export default {"iframe":"view_iframe__QzlCM","cancel":"view_cancel__11OIa","ttl":"view_ttl__9CESY"};